<div class="billing-card">
  <div class="card-header">
    <div class="header-icon">
      <mat-icon>receipt_long</mat-icon>
    </div>
    <h2 class="card-title">{{ 'ACCOUNT.BILLING_TITLE' | translate }}</h2>
  </div>

  <div class="card-body">
    @if (billingAddress) {
      <div class="fields-grid">
        <div class="field-item">
          <label class="field-label">{{ 'ACCOUNT.ADDRESS_1' | translate }}</label>
          <jjames-input type="text" [placeholder]="billingAddress.firstAddressLine ?? '—'"></jjames-input>
        </div>

        <div class="field-item">
          <label class="field-label">{{ 'ACCOUNT.ADDRESS_2' | translate }}</label>
          <jjames-input type="text" [placeholder]="billingAddress.secondAddressLine ?? '—'"></jjames-input>
        </div>

        <div class="field-item">
          <label class="field-label">{{ 'ACCOUNT.POST_CODE' | translate }}</label>
          <jjames-input type="text" [placeholder]="billingAddress.postCode ?? '—'"></jjames-input>
        </div>

        <div class="field-item">
          <label class="field-label">{{ 'ACCOUNT.LOCALITY' | translate }}</label>
          <jjames-input type="text" [placeholder]="billingAddress.locality ?? '—'"></jjames-input>
        </div>

        <div class="field-item">
          <label class="field-label">{{ 'ACCOUNT.REGION' | translate }}</label>
          <jjames-input type="text" [placeholder]="billingAddress.region ?? '—'"></jjames-input>
        </div>

        <div class="field-item">
          <label class="field-label">{{ 'ACCOUNT.COUNTRY_CODE' | translate }}</label>
          <jjames-input type="text" [placeholder]="billingAddress.countryCode ?? '—'"></jjames-input>
        </div>
      </div>

      <div class="card-actions">
        <jjames-button variant="primary" size="md">
          {{ 'ACCOUNT.EDIT_ADDRESS' | translate }}
        </jjames-button>
      </div>
    } @else {
      <div class="empty-billing-state">
        <mat-icon class="empty-icon">home_work</mat-icon>
        <p class="empty-text">No billing address on file.</p>
        <jjames-button variant="primary" size="md">
          {{ 'ACCOUNT.ADD_ADDRESS' | translate }}
        </jjames-button>
      </div>
    }
  </div>
</div>